import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, retry, timer, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Accessory {
  id: string;
  name: string;
  imageUrl: string;
  thumbnailUrl: string;
  price: number;
  originalPrice: number;
}

export interface ApiResponse<T> {
  success: boolean;
  message: string | null;
  errors: any;
  data: T;
}

@Injectable({
  providedIn: 'root'
})
export class HomeDesigntemplateService {
  apiUrl!: string;
  apiV!: string;

  constructor(private httpClient: HttpClient) {
    // Gọi y hệt như trong WishlistApiService
    this.apiUrl = environment.apiURL; 
    
    // Nếu trong environment của bạn không cấu hình 'version' thì thêm || 'v1' để tránh lỗi nhé
    this.apiV = environment.version || 'v1'; 
  }

  getFreeAccessories(take: number = 14): Observable<ApiResponse<Accessory[]>> {
    // Sử dụng HttpParams truyền tham số cho chuẩn mực
    let params = new HttpParams();
    params = params.append("Take", take.toString());

    return this.httpClient.get<ApiResponse<Accessory[]>>(
      `${this.apiUrl}/api/${this.apiV}/LibrariesCategory/GetFreeAccessories`,
      { params: params }
    ).pipe(
      retry({
        count: 3, // Thử lại tối đa 3 lần
        delay: (error: HttpErrorResponse, retryCount: number) => {
          if (error.status === 503 || error.status === 0) {
            console.warn(`[GetFreeAccessories API] Lỗi mạng/CORS (Status: ${error.status}), đang thử lại lần ${retryCount}...`);
            return timer(retryCount * 1000); // Thử lại sau 1s, 2s, 3s
          }
          return throwError(() => error);
        }
      })
    );
  }

  getPaidAccessories(take: number = 14): Observable<ApiResponse<Accessory[]>> {
    let params = new HttpParams();
    params = params.append("Take", take.toString());

    return this.httpClient.get<ApiResponse<Accessory[]>>(
      `${this.apiUrl}/api/${this.apiV}/LibrariesCategory/GetPaidAccessories`,
      { params: params }
    ).pipe(
      retry({
        count: 3, // Thử lại tối đa 3 lần
        delay: (error: HttpErrorResponse, retryCount: number) => {
          if (error.status === 503 || error.status === 0) {
            console.warn(`[GetPaidAccessories API] Lỗi mạng/CORS (Status: ${error.status}), đang thử lại lần ${retryCount}...`);
            return timer(retryCount * 1000); // Thử lại sau 1s, 2s, 3s
          }
          return throwError(() => error);
        }
      })
    );
  }
}